import { Video } from 'ui/components/3-organisms/Video';

export const VideoFeature: React.FC<Umbraco.Video> = ({ content }) => <Video {...content?.properties} />;
